import * as React from 'react';
import LoadingDisplay from '../LoadingDisplay';

/**
 * This component will render only the children when processing = false
 * otherwise it will display a loading spinner with the provided
 * message
 */

interface Props {
  processing: boolean;
  message: string;
  style?: React.CSSProperties;
  loadingDisplayDivClassName?: string;
  loadingDisplaySpanClassName?: string;
  loadingDisplaySvgClassName?: string;
  loadingDisplayCircleClassName?: string;
}

class SpinningProgressWrapper extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    if (this.props.processing) {
      return (
        <LoadingDisplay 
          divClassName={this.props.loadingDisplayDivClassName} 
          spanClassName={this.props.loadingDisplaySpanClassName} 
          svgClassName={this.props.loadingDisplaySvgClassName} 
          circleClassName={this.props.loadingDisplayCircleClassName} 
          loadingMessage={this.props.message}
          style={this.props.style}
        />
      );
    }

    return this.props.children;
  }
}

export default SpinningProgressWrapper;



// WEBPACK FOOTER //
// ./src/Components/Compositional/SpinningProgressWrapper.tsx